<template>
  <footer class="bg-cream">
    <div class="container-large row" :class="borderTop ? 'border-top' : ''">
          <div class="basis-65-gap-1 col">
            <h5>Links</h5>
            <router-link to="/privacy-policy" class="nav-like">Privacy Policy</router-link>
            <router-link to="/shipping" class="nav-like">Shipping Policy</router-link>
            <router-link to="/returns" class="nav-like">Returns & Refunds</router-link>
            <router-link to="/terms-of-service" class="nav-like">Terms of service</router-link>
          </div>
          <div id="contact" class="basis-35-gap-1">
            <h5>Contact</h5>
            <p>PO Box 3222 Garibaldi Highlands PO, <br>
              Garibaldi Highlands BC V0N 1T0, <br>
              Canada </p>
            <p><a href="mailto:hello@redbluestories.com">hello@redbluestories.com</a></p>
          </div>
      <div class="mb-2 mt-2 basis-65-gap-1">
        <p class="width-70"><i>We live and work on the traditional, ancestral and unceaded territory of the Sḵwx̱wú7mesh (Squamish). We respect the land and we thank the Indigenous people who still live on and care for these lands.</i></p>
        <p class="copyright">©2026, Red + Blue Stories Inc. All rights reserved.<br/> Designed in Squamish, BC.</p>
      </div>
      <div class="basis-35-gap-1">
        <img src="../assets/img/icon_footer.png" id="footer-img">
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'Footer',
  props: ['borderTop'],
  methods: {
    scrollTo(elt) {
      var element = document.getElementById(elt);
      var topElt = element.offsetTop;
      window.scroll({top: topElt, left: 0, behavior: 'smooth'});
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/variables.scss';

#footer-img {
  margin-bottom: -.4em;
  align-self: flex-end;
  max-height: 250px;
}

.border-top {
   border-top: 1px solid $blue-hover;
}

footer {
  padding-top: 4em;

  .container-large {
    padding-top: 2em;
  }

  a.nav-like {
    width: auto;
    align-self: flex-start;
       color: $blue;
      &:hover, &.router-link-active, &.active  {
        color: $blue;
        &::after {
          content: "";
          display: inline-block;
          width: 10px;
          height: 10px;
          border-radius: 7.5px;
          background-color: $blue;
          position: absolute;
          right: -15px;
          top: calc(50% - 5px);
        }
      }
  }

  a.nav-like {
    text-transform: uppercase;
    font-size: 1em;
    font-weight: 500;
    line-height: 18.7px;
    margin: .2em 0 .2em 0;
    text-decoration: none;
    border-bottom: 2px solid transparent;
    padding: 0;
    background-color: transparent;
    border-radius: 0;
    position: relative;

    &:hover, &.router-link-active {
      cursor: pointer;
    }
  }

  &.bg-teal {
    background-color: $teal;
  }

  &.bg-blue {
    background-color: $blue;
  }

  &.bg-cream {
    .card {
      border-top: 1px solid $teal;
      border-left: 1px solid $teal;
      border-right: 1px solid $teal;
    }
  }

  .card {
    //width: 80%;
    margin: auto;
    background-color: $cream;
    padding: 2em;
    border-radius: 40px 40px 0 0;
  }

  .row {
    justify-content: space-between;
  }

  h5 {
    font-weight: 600;
    margin-bottom: 1em;
  }

  .copyright {
    font-size: 14px;
    font-weight: 600;
  }

  .mid {
    gap: .5em;
  }

  .right {
    width: 60%;
  }

  .left {
    width: 30%;
  }

  .mid, .right-s {
    width: 50%;
  }
}

@media only screen and (max-width: 1240px) {
  footer {
    .left, .right {
      width: 50%;
    }
    .mid, .right-s {
      width: 100%;
      padding: 0 3em;
    }

    .right {
      flex-direction: column;
      justify-content: space-between;
    }
  }
}

@media only screen and (max-width: 920px) {
  footer {
    padding-top: 2em;
    .card {
      .row {
        flex-direction: column;
      }
      .left, .right, .mid, .right-s {
        width: 100%;
        padding: 0;
      }
      .mid {
        margin: 2em 0;
      }
    }
  }
}

</style>